import essyLogo from "../../../assets/essy-logo-simple.svg";
import ButtonGroup from "../../../components/ButtonGroup";

export default function WhyEssy() {
  return (
    <section id="why_essy">
      <div className="container">
        <div className="why-essy-wrapper">
          <img src={essyLogo} alt="logo" />
          <h2>Why Essy?</h2>
          <p>
            We built Essy to make hiring simpler for everyone. Most companies
            spend months messaging people who don’t respond. Most candidates get
            offers that never fit.
          </p>
          <p>
            We’ve spent over a decade recruiting Sales Engineers and technical
            talent for SaaS and AI companies, and we built Essy to remove that
            gap - connecting companies only with people who are open, relevant,
            and ready to engage.
          </p>
          <p>
            It’s straightforward: fewer steps, less waste, better results for
            both sides.
          </p>
          <ButtonGroup />
        </div>
      </div>
    </section>
  );
}
